module.exports = __webpack_public_path__ + "img/icon-buy.017d4e18.svg";